import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import {
  TUpdateCardAutoChargeRequestSchema,
  TUpdateCardAutoChargeResponseSchema,
} from "./updateCardAutoCharge.schema";

export const updateCardAutoCharge = (axios: IAxiosInstance) => {
  return async (requestBody: TUpdateCardAutoChargeRequestSchema) => {
    const { companyID, customerAccountID, cardUpdates } = requestBody;
    const response =
      await axios.noRetry.patch<TUpdateCardAutoChargeResponseSchema>(
        `/customer-accounts/${customerAccountID}/updateCardAutoCharge`,
        {
          companyID,
          cardUpdates,
        }
      );
    return response.data;
  };
};
